<template>
    <div class="container-fluid h-100">
      <!-- Imagen principal de havoblog -->
      <div 
        :style="{ 'background-image': 'url(' + image + ')' }" 
        class="content-havoblog" 
        id="content-havoblog-id"
        :alt="name"
      >
        <div class="red-overlay"></div>
      </div>
      <!-- Título -->
      <div class="title_blog">
        <h1>
          {{ title != null ? title : '' }}
        </h1>
      </div>
      <!-- Subtítulo -->
      <div class="subtitle_blog">
        <h2>
          {{ subtitle != null ? subtitle : '' }}
        </h2>
      </div>
      <!-- Descripción del blog -->
      <div class="description_blog">
        <pre>
          {{ description != null ? description : '' }}
        </pre>
      </div>
      <!-- video del blog -->
      <div class="video_blog">
        <div v-if="type_video == 1">
          <video
            controls
            title="video havoblog"
            :muted="false"
            :volume="10"
          >
          <source :src="video" type="video/mp4">
          </video>
        </div>
        <div v-else-if="type_video == 2">
          <iframe
            title="video havoblog"
            :src="youtube_link"
          >
          </iframe>
        </div>
      </div>
      <!-- Carrusel de imágenes -->
      <template v-if="images.length > 0">
        <div class="carousel">
          <div class="carousel-images">
            <img style="background-size:cover;" :src="currentImage" :alt="'imagen ' + name">
            <img style="background-size:cover;" :src="currentImage2" :alt="'imagen ' + name">
          </div>
          <button class="prev-button" @click="prevImage">Anterior</button>
          <button class="next-button" @click="nextImage">Siguiente</button>
        </div>
      </template>
  
      <!-- Comentarios de este blog -->
      <h2 class="total-comments">Comentarios ({{ cantComments == null ? 0 : cantComments }})</h2>
      <div class="all-comment-users">
        <div class="comment-user">
          <!-- <h2 class="total-comments">Comentarios ({{ cantComments == null ? 0 : cantComments }})</h2> -->
          <br>
          <div v-for="comment in allComments" :key="comment.id">
            <div style="width:65%; text-align:left; display:block; padding:10px 0px 15px 0px;">
              <span class="name-user-comment">{{ comment.name }}</span><br>
              <span class="date-user-comment">{{ comment.created_at }}</span><br><br>
              <span class="message-user-comment">{{ comment.description }}</span><br>
              <span v-if="comment.response" class="message-user-comment-response"> Respuesta {{ comment.response_date }} : {{ comment.response }}</span><br>
            </div>
            <div style="border-bottom:2px solid gray;"></div>
          </div>
        </div>
      </div>
  
      <!-- Comentario del blog -->
      <div v-if="aceptComments == 1" class="content-comment" id="content-comment-id" alt="Fondo comentarios">
        <div class="franja"></div>
        <h2>Publica una respuesta</h2>
        <div class="name-email" style="display:flex;">
          <div class="col-12 col-lg-5 name-comment">
            <div class="form-group">
              <input
                :class="{ 'is-danger': errors.name }"
                type="text"
                v-model="form.name"
                class="form-control"
                placeholder="Nombre"
              />
            </div>
            <span
              v-if="errors.name"
              class="text-warning text-danger float-left small error-danger mb-2"
            >{{ errors.name }}</span
            >
          </div>
          <div class="col-12 col-lg-5 email-comment">
            <div class="form-group">
              <input
                :class="{ 'is-danger': errors.email }"
                type="text"
                v-model="form.email"
                class="form-control"
                placeholder="Email"
              />
            </div>
            <span
              v-if="errors.email"
              class="text-warning text-danger float-left small error-danger mb-2"
            >{{ errors.email }}</span
            >
          </div>
        </div>
        <div class="col-12 col-lg-10 message-comment">
          <div class="form-group">
            <textarea
              :class="{ 'is-danger': errors.description }"
              rows="4"
              type="text"
              v-model="form.description"
              class="form-control"
              placeholder="Mensaje"
            />
          </div>
          <span
            v-if="errors.description"
            class="text-warning text-danger float-left small error-danger mb-2"
          >{{ errors.description }}
          </span><br><br>
          <!-- btn enviar comentario -->
          <div class="row">
            <button
              @click="sendComment()"
              type="button"
              class="btn-send-comment"
            >
              <template v-if="loading.changeDoc">
                ENVIANDO...
              </template>
              <template v-else>ENVIAR</template>
            </button>
          </div>
        </div>
      </div>
  
      <!-- Modal para ir a las redes sociales de HavolineColombia -->
      <div
        class="modal fade"
        id="modalRRSS"
        tabindex="-1"
        role="dialog"
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
      >
        <div style="min-width:45%;" class="modal-dialog modal-dialog-centered" role="document">
          <div class="modal-content modalRRSS" alt="fondo modal redes">
            <div class="content_btn_close">
              <img
                src="../../../assets/iconsRRSS/logo_close.png"
                width="20"
                title="cerrar popup"
                alt="cerrar popup"
                @click="closedModal()"
              />
            </div>
            <div style="margin-top:20px;" class="mr-md-4">
              <img
                src="../../../assets/iconsRRSS/logo_havoline.png"
                width="150"
                title="logo havoline"
                alt="logo havoline"
              />
            </div>
            <div class="modal_content_rrss">
              <h5
                class="modal-title"
                id="exampleModalLabel"
                style="color:#6c757d; margin:auto;"
              >
                <span class="text_white">Síguenos en nuestras redes </span><span class="text_yellow">para que no <br> te pierdas de todo nuestro contenido.</span>
              </h5>
            </div>
            <div style="margin:auto;" class="modal_footer_rrs">
              <div class="row pt-4 pb-3 d-flex justify-content-center">
                <div class="">
                  <a href="https://www.instagram.com/havolinecolombia" target="_blank">
                    <img 
                      height="40" 
                      width="40" 
                      src="../../../assets/iconsRRSS/logo_instagram.png"
                      title="Instagram HavolineColombia"
                      alt="Instagram HavolineColombia"
                    />
                  </a>
                  <a href="https://www.facebook.com/HavolineColombia/" target="_blank" > 
                    <img
                      style="margin-left:15px"
                      height="40"
                      width="40"
                      src="../../../assets/iconsRRSS/logo_facebook.png"
                      title="Facebook HavolineColombia"
                      alt="Facebook HavolineColombia"
                    />
                  </a>
                  <a href="https://www.youtube.com/ChevronColombia/" target="_blank" > 
                    <img
                      style="margin-left:15px"
                      height="40"
                      width="40"
                      src="../../../assets/iconsRRSS/logo_youtube.png"
                      title="YouTube HavolineColombia"
                      alt="YouTube HavolineColombia"
                    />
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
  
      <!-- Calificación -->
      <!-- <div style="background-color: white;">
        <template>
          <h3>Califica este Havoblog</h3>
          <div class="text-center">
            <div class="text-center">
              <v-rating
                style="background-color:gray"
                v-model="rating"
                :icons="{ 'full-icon': 'mdi-star' }"
                @change="addScoreBlog()"
              ></v-rating>
            </div>
            <pre>{{ rating }}</pre>
          </div>
        </template>
      </div> -->
  
      <!-- Regresar -->
      <button
        @click="back()"
        type="button"
        class="btn-back"
      >
        Regresar al listado de Havoblogs
      </button>
    </div>
</template>
    
<script>
    import $ from "jquery";
    import axios from 'axios'
    import { mdiStarOutline, mdiStar, mdiStarHalf } from '@mdi/js'
    
    export default {
      data() {
        return {
          mdiStarOutline,
          mdiStar,
          mdiStarHalf,
          rating: 3,
          blog: [],
          images: [],
          currentImageIndex: 0,
          image: null,
          name: null,
          title: null,
          subtitle: null,
          description: null,
          video: null,
          youtube_link: null,
          aceptComments: null,
          allComments: [],
          cantComments: null,
          form: {
            name: null,
            email: null,
            description: null,
          },
          errors: {
            name: false,
            email: false,
            description: false,
          },
          loading: {
            changeDoc: false,
          },
          blogId: null,
          nameSlug: null,
        };
      },
      computed: {
        currentImage() {
          return this.images[this.currentImageIndex]
        },
        currentImage2() {
          return this.images[this.currentImageIndex + 1]
        }
      },
      methods: {
        back(){
          window.history.back();
        },
        clear(){
          this.form.name = null;
          this.form.email = null;
          this.form.description = null;
          setTimeout(() => {
            this.errors.name = false;
            this.errors.email = false;
            this.errors.description = false;
          },0);
        },
        validform(){
          let app = this;
          if (!app.form.name) {
            app.errors.name = "El nombre es requerido.";
            return false;
          }
          if (!app.form.email) {
            app.errors.email = "El email es requerido.";
            return false;
          }
          if (!app.form.description) {
            app.errors.description = "El mensaje es requerida.";
            return false;
          }
          if(app.form.description.length < 5){
            app.errors.description = "El mensaje es demasiado corto.";
            return false;
          }
          if (
            !app.errors.name &&
            !app.errors.email &&
            !app.errors.description
          ) {
            return true;
          }
          return false;
        },
        sendComment(){
          if (this.validform()) {
            this.saveComment();
          }
        },
        saveComment(){
          const formData = new FormData();
          formData.append("name", this.form.name);
          formData.append("email", this.form.email);
          formData.append("description", this.form.description);
          formData.append("havoblog_post_id", this.blogId);
  
          this.loading.changeDoc = true;
          axios
          .post("havoblog/addCommentBlog", formData)
          .then((res) => {
            if (res.data.cod == 0){
              this.$swal({
                confirmButtonColor: "#dc3545",
                icon: "success",
                title: "Muy bien",
                text: res.data.message,
              });
              this.loading.changeDoc = false;
              this.clear();
              this.getBlog(this.blogId);
            }
          })
          .catch((error) => {
            this.loading.changeDoc = false;
            this.$swal({
              confirmButtonColor: "#dc3545",
              icon: "error",
              title: "Oops...",
              text: error.response.data.message,
            });
          });
        },
        getBlog(id){
          let app = this;
          axios
          .get("havoblog/infoBlog/" + id)
          .then((res) => {
            if(res.data.cod == 0){
              app.blog = res.data.data[0];
              // console.log('app.blog ', JSON.stringify(app.blog));
              app.image = app.blog.img;
              app.name = app.blog.name;
              app.title = app.blog.title;
              app.subtitle = app.blog.subtitle;
              app.description = app.blog.description;
              app.type_video = app.blog.type_video;
              app.video = app.blog.video;
              app.youtube_link = app.blog.youtube_link;
              app.blog.havoblog_post_files.forEach(element => {
                if(element.url){
                  app.images.push(element.url);
                }
              });
              app.aceptComments = app.blog.comment;
              app.allComments = app.blog.havoblog_post_comments;
              app.cantComments = app.blog.havoblog_post_comments.length;
            }
            else{
              app.$swal({
                confirmButtonColor: "#dc3545",
                icon: "error",
                title: "Oops...",
                text: res.data.message
              });
            }
          })
          .catch((error) => {
            console.log('this is the error ', error);
          })
        },
        prevImage() {
          if (this.currentImageIndex > 0) {
            this.currentImageIndex--
          }
        },
        nextImage() {
          if (this.currentImageIndex < this.images.length - 1) {
            this.currentImageIndex++
          }
        },
        registerViews(id){
          let app = this;
          axios
          .put("havoblog/addViewBlog/" + id)
          .then((res) => {
            if(res.data.cod == 0){
              // console.log('Se registró la vista');
            }
            else{
              app.$swal({
                confirmButtonColor: "#dc3545",
                icon: "error",
                title: "Oops...",
                text: res.data.message
              });
            }
          })
          .catch((error) => {
            console.log('this is the error ', error);
          });
        },
        // addScoreBlog(){
        //   let app = this;
        //   let data = {
        //     havoblog_post_id: app.blogId,
        //     amount: app.rating,
        //   }
        //   console.log('data ', JSON.stringify(data));
        //   axios
        //   .put("havoblog/addScoreBlog", data)
        //   .then((res) => {
        //     if(res.data.cod == 0){
        //       app.$swal({
        //         confirmButtonColor: "#dc3545",
        //         icon: "succes",
        //         title: "Muy bien",
        //         text: res.data.message
        //       });
        //     }
        //     else{
        //       app.$swal({
        //         confirmButtonColor: "#dc3545",
        //         icon: "error",
        //         title: "Oops...",
        //         text: res.data.message
        //       });
        //     }
        //   })
        //   .catch((error) => {
        //     console.log('this is the error ', error);
        //   });
        // },
        closedModal(){
          $("#modalRRSS").modal("hide");
        }
      },
      mounted(){
        this.blogId = localStorage.getItem('blogId');
        this.nameSlug = localStorage.getItem('nameSlug');
        this.getBlog(this.blogId);
        this.registerViews(this.blogId);
        if (!sessionStorage.getItem('modalRRSS4')){
          $("#modalRRSS").modal("show");
          sessionStorage.setItem('modalRRSS4', 1);
        }
      },
      watch: {
        "form.name": function(newV) {
          if (!newV) {
            this.errors.name = "El nombre es requerido.";
          } else {
            this.errors.name = false;
          }
        },
        "form.email": function(newV) {
          if (!newV) {
            this.errors.email = "El email es requerido.";
          } else {
            this.errors.email = false;
          }
        },
        "form.description": function(newV) {
          if (!newV) {
            this.errors.description = "El mensaje es requerida.";
          } else {
            this.errors.description = false;
          }
        },
        "rating": function(){
          this.addScoreBlog();
        }
      },
    };
</script>
      
<style scoped>
  .container-fluid,
  .container-lg,
  .container-md,
  .container-sm,
  .container-xl {
    background-color: #F9F6F6;
    padding-right: 0px !important;
    padding-left: 0px !important;
    overflow: hidden;
    max-width: 90%;
  }
  /* --------------------------------------------------------------------- */
  #content-havoblog-id {
    height: 75vh;
    margin: auto;
  }
  .content-havoblog{
    margin-top: 55px !important;
    background-size: cover;
    /* background-image: url("../../../assets/img/fondo_superior.png"); */
    background-position: center center;
    background-color: "#171717";
  }
  .red-overlay {
    margin-top: 55px;
    position: absolute;
    top: 0;
    left: 50%;
    transform: translateX(50%);
    width: 30%;
    height: 75vh;
    background-color: rgb(153, 0, 0, 0.7);
    z-index: 1;
  }
  .title_blog{
    color: black;
    text-align: left;
    padding: 10px 5px 10px 0px;
    /* font-family: "GothamBoldItalic"; */
  }
  .subtitle_blog{
    color: black;
    text-align: left;
    padding: 10px 5px 10px 0px;
    /* font-family: "GothamBookItalic"; */
  }
  .description_blog > pre{
    color: black;
    text-align: left;
    padding: 10px 5px 10px 0px;
    font-family: inherit;
    white-space: pre-wrap;
  }
  .video_blog iframe{
    width: 100%;
    height: 80vh;
    margin: 20px auto 20px auto;
  }
  .video_blog video{
    min-width: 100%;
    height: 80vh;
    margin: 20px auto 20px auto;
  }
  .carousel {
    position: relative;
  }
  .carousel-images {
    display: flex;
    flex-wrap: nowrap;
    overflow-x: hidden;
  }
  .carousel-images img {
    width: 50%;
    height: 350px;
    object-fit: cover;
    /* margin-right: 50px; */
  }
  .carousel-images img:first-child {
    margin-right: 50px;
  }
  .prev-button,
  .next-button {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    padding: 10px;
    font-size: 16px;
    color: #dc3545;
    background-color: rgba(0, 0, 0, 0.8);
    border: none;
    cursor: pointer;
    font-weight: bold;
  }
  .prev-button {
    left: 0;
  }
  .next-button {
    right: 0px;
  }
  .all-comment-users{
    background-color: #F2F2F2;
    margin-top: 40px !important;
    padding: 20px 10px 20px 70px;
    height: 300px;
    overflow-y: scroll;
  }
  .comment-user{
    width: 100%;
    margin: 0px auto 0px 0px;
  }
  .total-comments{
    padding: 20px 10px 0px 70px;
    color: black;
    font-size: 30px;
    margin: 20px auto -10px 0px;
    min-width: 100% !important;
    text-align: left;
    font-weight: lighter;
  }
  .name-user-comment{
    color: black;
    font-size: 20px;
    font-weight: bold;
  }
  .date-user-comment{
    color: black;
    font-size: 15px;
    font-weight: lighter;
  }
  .message-user-comment{
    color: black;
    font-size: 14px;
    font-weight: lighter;
  }
  .message-user-comment-response{
    color: black;
    font-size: 14px;
    font-weight: lighter;
    margin-left: 20px;
    font-style: italic;
  }
  #content-comment-id {
    height: auto;
    margin: auto;
  }
  .content-comment{
    background-size: cover;
    background-image: url("../../../assets/img/fondo_comments.jpg");
    background-position: center center;
    background-color: "#171717";
    padding-bottom: 4%;
  }
  .franja{
    height: 60px;
    background-color: rgba(255, 255, 255, 0.3);
    margin-bottom: 40px;
  }
  .content-comment h2{
    max-width: 45%;
    font-size: 40px;
    padding: 8px 8px 8px 10px;
    font-weight: bold;
    color: white;
    background-color: rgba(0, 0, 0, 0.6);
    border-radius: 0px 50px 50px 0px;
  }
  .name-comment{
    padding: 15px 15px 15px 70px;
  }
  .name-comment input{
    padding: 25px;
  }
  .email-comment{
    padding: 15px 15px 15px 10px;
  }
  .email-comment input{
    padding: 25px;
  }
  .message-comment{
    padding: 15px 15px 15px 70px;
  }
  .btn-send-comment{
    padding: 10px 25px 10px 25px;
    background-color: #D33722;
    font-weight: bold;
    border-radius: 3px;
    text-align: left;
  }
  .text-warning{
    color: white;
  }
  .btn-back{
    background-color: #dc3545;
    color: white;
    font-size: 15px;
    font-weight: bold;
    padding: 8px 20px 8px 20px;
    border-radius: 3px;
    margin: 30px auto 30px 0px !important;
  }
  .modalRRSS{
    background-image: url('../../../assets/iconsRRSS/fondo_modalrrss.jpg');
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
  }
  .modal_content_rrss, .modal_footer_rrs{
    padding: 20px 15px 30px 15px;
  }
  .content_btn_close{
    margin: 20px 25px auto auto;
    cursor: pointer;
  }
  .text_white{
    color: white;
    font-weight: bold;
  }
  .text_yellow{
    color: #ffce00;
    font-weight: bold;
  }
  
  /* Tablet */
  @media (max-width: 780px) {
    #content-havoblog-id {
      height: 50vh;
    }
    .red-overlay {
      height: 50vh;
    }
    .title_blog > h1{
      font-size: 30px;
    }
    .subtitle_blog > h2{
      font-size: 26px !important;
    }
    .description_blog > pre{
      font-size: 17px !important;
    }
    .carousel-images img {
      width: 100%;
      height: 250px;
    }
    .carousel-images img:first-child {
      margin-right: 0px;
    }
    .video_blog iframe{
      width: 100%;
      height: 50vh;
    }
    .video_blog video{
      width: 100%;
      height: 50vh;
    }
    .total-comments{
      font-size: 28px;
    }
    .all-comment-users{
      padding: 20px 10px 20px 20px;
    }
    .name-comment{
      padding: 15px 15px 15px 15px !important;
    }
    .name-comment input{
      padding: 20px;
    }
    .email-comment{
      padding: 15px 15px 15px 15px !important;
    }
    .email-comment input{
      padding: 20px;
    }
    .message-comment{
      padding: 15px 15px 15px 15px;
    }
    .content-comment h2{
      max-width: 50%;
      font-size: 20px !important;
    }
    .name-email{
      display: block !important;
    }
    .name-comment{
      padding: 15px 15px 15px 70px;
      min-width: 83% !important;
    }
    .email-comment{
      padding: 15px 15px 15px 70px;
      min-width: 83% !important;
    }
    .btn-send-comment{
      margin: auto;
    }
  }
  
  /* Movil */
  @media (max-width: 500px) {
    .content-comment h2{
      max-width: 60%;
      font-size: 16px !important;
    }
  }
</style>